import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { connect } from "react-redux";
import {
  Sidebar,
  Menu,
  MenuItemLink,
  getResources,
  Authenticated,
  changeLocale as changeLocaleAction,
  useTranslate,
  usePermissions
} from "react-admin";
// import { MenuItem } from "@mui/material/MenuItem";
import { withStyles } from "@mui/styles";
// import Divider from '@mui/material/Divider';
import { withRouter } from "react-router-dom";
// import ListSubheader from '@mui/material/ListSubheader';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import DraftsIcon from '@mui/icons-material/Drafts';
// import SendIcon from '@mui/icons-material/Send';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import StarBorder from '@mui/icons-material/StarBorder';
import { Scrollbars } from "react-custom-scrollbars";
import {
  Dashboard as DashboardIcon,
  AccountCircle as AccountIcon,
  SettingsCell as OrderIcon,
  Person as PersonIcon,
  Loyalty as LoyaltyIcon,
} from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MessageIcon from "@mui/icons-material/Message";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import ProductImageIcon from "@mui/icons-material/Image";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import RedeemIcon from "@mui/icons-material/Redeem";
import StarIcon from "@mui/icons-material/Star";
import PaymentIcon from "@mui/icons-material/Payment";
import FactoryIcon from '@mui/icons-material/Factory';
// import SettingsIcon from '@mui/icons-material/Settings';

import {
  GetCurrentUserRoles,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  loginType,
  DigitalOrderSystem
} from "./common/common";
// import environmentVariables from './utils/get-environment-variables';
import {
  gapi,
  loadAuth2,
  loadAuth2WithProps,
  loadClientAuth2,
} from "gapi-script";
import environmentVariables from "./globs/utils/get-environment-variables";

const googleClientID = "" + process.env.REACT_APP_GOOGLE_CLIENT_ID + "";
const styles = {
  root: {}, // Style applied to the MenuItem from material-ui
  active: { fontWeight: "bold" }, // Style applied when the menu item is the active one
  icon: {}, // Style applied to the icon
};

const MyMenu = (props) => {
  const [tempDisable, setTempDisable] = useState(true);
  const [umOpen, setUmOpen] = useState(false);
  const [aOpen, setAOpen] = useState(false);
  const [uOpen, setUOpen] = useState(false);
  const [lpOpen, setLpOpen] = useState(false);
  const [proofOpen, setProofOpen] = useState(false);
  const [bashBanner, setBashBanner] = useState(false);
  const [emailerBanner, setEmailerBanner] = useState(false);
  const [prodImg, setProdImg] = useState(false);
  const [clickitProd, setClickitProd] = useState(false);
  const [pOpen, setPOpen] = useState(false);
  const [slOpen, setSlOpen] = useState(false);
  const [scOpen, setScOpen] = useState(false);
  const [omOpen, setOmOpen] = useState(false);
  const [proofStatus, setProofStatus] = useState(false);
  const [dashBannerStatus, setDashBannerStatus] = useState(false);
  const [salesOfficersStatus, setSalesOfficersStatus] = useState(false);
  const [whiteListUsers, setWhiteListUsers] = useState(false);
  const [settingListStatus, setSettingListStatus] = useState(false);
  const [hideReceivedYesNoStatus, setHideReceivedYesNoStatus] = useState(false);
  const [complaintStatus, setComplaintStatus] = useState(false);
  const [isnotifOpen, setIsnotifOpen] = useState(false);
  const [soNotifOpen, setSoNotifOpen] = useState(false);
  const [tcOpen, setTcOpen] = useState(false);
  const [pmOpen, setPmOpen] = useState(false);
  const [plantOpen, setPlantOpen] = useState(false);
  const [svOpen, setSvOpen] = useState(false);
  const [smOpen, setSmOpen] = useState(false);
  const [soSmOpen, setSoSmOpen] = useState(false);
  const [pbpOpen, setPbpOpen] = useState(false);
  const [menuSettings, setMenuSettings] = useState({
    config: false,
    admin: false,
    users: false,
    loyaltyPoints: false,
    product: false,
    sales_order: false,
    schemes: false,
    other: false,
    daily_report: true,
    proof_of_payment: false,
    dashboard_banners: false,
    dashboard_banners_web: false,
    productsmaster: false,
    sales_officers: false,
    whitelist_user: false,
    setting: false,
    termsNcond: false,
    termConditionId: 1,
    promotionNotificationId: 1,
    isSalesOfficerPresent: false,
    notification: true,
    marketing: true,
    promotion: true,
    plants: true,
    survey: true,
    priceUpdate: false,
    orderBlock: false,
  });
  const [language_id, setLanguage_id] = useState(0);
  const [is_uae_sms_del, setIs_uae_sms_del] = useState(false);
  const [productsMasterStatus, setProductsMasterStatus] = useState("");
  const [targetUpload, setTargetUpload] = useState("");
  const [loyaltyPointsList, setLoyaltyPointsList] = useState("");
  const [paymentList, setPaymentList] = useState("");
  const [isSalesOfficerPresent, setIsSalesOfficerPresent] = useState("");
  const userLocale = getLocalStorageKey("locale");
  const [menuObj, setMenuObj] = useState({});
  let roleData = GetCurrentUserRoles();
  const { permissions } = usePermissions();
  const localStorageAppType = getLocalStorageKey("app_type");
  const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");

  useEffect(() => {
    if (localStorageAppType === "HOLCIM") {
      setBaseThemeColor("holcimtheme");
    } else {
      setBaseThemeColor("clickittheme");
    }
  }, [localStorageAppType]);

  useEffect(() => {
    const userLocale = getLocalStorageKey("locale");
    const proofStatus = getLocalStorageKey("proof_of_payment");
    const dashBannerStatus = getLocalStorageKey("dashboard_banners");
    const dashBannerWebStatus = getLocalStorageKey("dashboard_banners_web");
    const productsMasterStatus = getLocalStorageKey("productsmaster");
    const hideReceivedYesNoStatus = getLocalStorageKey("hide_received_yes_no");
    const complaintStatus = getLocalStorageKey("complaint_mgmt");
    const salesOfficersStatus = getLocalStorageKey("sales_officers");
    const settingListStatus = getLocalStorageKey("setting_list");
    const whiteListUsers = getLocalStorageKey("whitelist_user");
    const targetUpload = getLocalStorageKey("target_upload");
    const loyaltyPointsList = getLocalStorageKey("loyalty_points");
    const isSalesOfficerPresent = getLocalStorageKey(
      "is_sales_off_app_present"
    );
    const paymentList = getLocalStorageKey("payment_list");
    const is_uae_sms_del = getLocalStorageKey("opco")?.country_id === 13;
    setMenuSettings({
      ...menuSettings,
      termConditionId: getLocalStorageKey("term_condition_id"),
      promotionNotificationId: getLocalStorageKey("promotion_notification_id"),
    });
    const term_and_conditionsdata = getLocalStorageKey("term_condition_data");
    if (term_and_conditionsdata && term_and_conditionsdata.length > 0) {
      setLanguage_id(term_and_conditionsdata[0].id);
    }
    if (proofStatus) {
      setProofStatus(proofStatus);
    }
    if (dashBannerStatus) {
      setDashBannerStatus(dashBannerStatus);
    }
    if (productsMasterStatus) {
      setProductsMasterStatus(productsMasterStatus);
    }
    if (salesOfficersStatus) {
      setSalesOfficersStatus(salesOfficersStatus);
    }
    if (whiteListUsers) {
      setWhiteListUsers(whiteListUsers);
    }
    if (settingListStatus) {
      setSettingListStatus(settingListStatus);
    }
    if (hideReceivedYesNoStatus) {
      setHideReceivedYesNoStatus(hideReceivedYesNoStatus);
    }
    if (complaintStatus) {
      setComplaintStatus(complaintStatus);
    }
    if (targetUpload) {
      setTargetUpload(targetUpload);
    }
    if (loyaltyPointsList) {
      setLoyaltyPointsList(loyaltyPointsList);
    }
    if (paymentList) {
      setPaymentList(paymentList);
    }
    if (userLocale) {
      // props.changeLocale(userLocale);
    }
    if (isSalesOfficerPresent) {
      setIsSalesOfficerPresent(isSalesOfficerPresent);
    }
    if (is_uae_sms_del) {
      setIs_uae_sms_del(is_uae_sms_del);
    }
    const currPath = props?.location?.pathname;
    let menuObj = {};
    if (
      currPath === "/countries" ||
      currPath === "/regions" ||
      currPath === "/branches" ||
      currPath === "/subbranch" ||
      currPath === "/opcos" ||
      currPath === "/bussdealermap" ||
      currPath === "/busstosaleofficermap"
    ) {
      menuObj["umOpen"] = true;
    } else if (
      currPath === "/businesses" ||
      currPath === "/dealer" ||
      currPath === "/salesofficer" ||
      currPath === "/onboardretailer" ||
      currPath === "/customers"
    ) {
      menuObj["uOpen"] = true;
    } else if (
      currPath === "/productsmaster" ||
      currPath === "/prodmasteropbrmap" ||
      currPath === "/product"
    ) {
      menuObj["pOpen"] = true;
    } else if (
      currPath === "/sales" ||
      currPath === "/customer_payments" ||
      currPath === "/digital_orders"
    ) {
      menuObj["slOpen"] = true;
    } else if (
      currPath === "/loyaltys" ||
      currPath === "/scheme" ||
      currPath === "/tagtoschememap" ||
      currPath === "/dashbanner"
    ) {
      menuObj["scOpen"] = true;
    } else if (
      currPath === "/tag" ||
      currPath === "/language" ||
      currPath === "/cntrylangmap"
    ) {
      menuObj["omOpen"] = true;
    } else if (currPath === "/proof_of_payments") {
      menuObj["proofOpen"] = true;
    } else if (currPath === "/dashboard_banners") {
      menuObj["emailerBanner"] = true;
    } else if (currPath === "/dashboard_banners") {
      menuObj["bashBanner"] = true;
    } else if (currPath === "/dashboard_banners_web") {
      menuObj["bashBannerWeb"] = true;
    } else if (currPath === "/productsmaster") {
      menuObj["prodImg"] = true;
    } else if (currPath === "/clickit_products") {
      menuObj["clickitProd"] = true;
    } else if (
      currPath === "/logins_reports" ||
      currPath === "/orders_reports" ||
      currPath === "/ordering_reports" ||
      currPath === "/activity_reports"
    ) {
      menuObj["rpOpen"] = true;
    }
    setMenuObj(menuObj);
    setRoleWiseMenu();
  }, []);

  const loggedInUserValidity = async () => {
    console.log(
      "googleClientID inside loggedInUserValidity===>",
      googleClientID
    );
    const client_id = googleClientID;

    const initSigninV2 = () => {
      gapi.auth2
        .init({
          client_id: client_id,
        })
        .then((res) => {
          // now auth2 is fully initialized
          // console.log('auth2 init success', res);
          console.log("isSignedIn====>", res.isSignedIn.le); //now this always returns correctly
          if (!res.isSignedIn.le) {
            props.history.push({
              pathname: "/login",
            });
          }
        });
    };
    // gapi.load("auth2", initSigninV2);
    // let auth2 = await loadAuth2(gapi, client_id);
  };

  const setRoleWiseMenu = () => {
    const isMadagascar = getLocalStorageKey("opco")?.id === 15;
    let roleData = GetCurrentUserRoles();
    const is_uae_user = getLocalStorageKey("opco")?.id === 13;
    let currMenuSett = menuSettings;

    if (roleData === false) {
      return false;
    }

    if (roleData.indexOf("$sa") > -1) {
      currMenuSett = {
        // config: true,
        users: true,
        loyaltyPoints: true,
        // product: true,
        sales_order: true,
        // schemes: true,
        // other: true,
        // daily_report: true,
        survey: true,
        promotion: true,
        plants: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$sdo") > -1) {
      if (is_uae_user) {
        setComplaintStatus(false);
        setIsSalesOfficerPresent(false);
        currMenuSett = {
          users: true,
          sales_order: true,
          proof_of_payment: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
        };
      } else {
        currMenuSett = {
          config: false,
          sales_order: true,
          admin: false,
          users: true,
          proof_of_payment: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
          survey: true,
          promotion: true,
          plants: true,
          marketing: true,
          notification: true,
        };
      }
    } else if (roleData.indexOf("$ca") > -1) {
      if (is_uae_user) {
        setComplaintStatus(false);
      }
      currMenuSett = {
        config: false,
        admin: true,
        users: true,
        product: false,
        sales_order: true,
        proof_of_payment: true,
        dashboard_banners: true,
        dashboard_banners_web: true,
        productsmaster: true,
        sales_officers: true,
        whitelist_user: true,
        survey: true,
        promotion: true,
        plants: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$cs") > -1) {
      currMenuSett = {
        config: false,
        sales_order: true,
        users: true,
        survey: true,
        promotion: true,
        plants: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$csa") > -1) {
      if (isMadagascar) {
        currMenuSett = {
          config: false,
          admin: true,
          users: true,
          loyaltyPoints: true,
          product: false,
          sales_order: true,
          schemes: false,
          other: false,
          daily_report: false,
          proof_of_payment: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
          sales_officers: true,
          whitelist_user: true,
          setting: true,
          termsNcond: true,
          priceUpdate: true,
          survey: true,
          promotion: true,
          plants: true,
          marketing: true,
          notification: true,
          orderBlock: true,
        };
      } else {
        currMenuSett = {
          config: false,
          admin: true,
          users: true,
          loyaltyPoints: true,
          product: false,
          sales_order: true,
          schemes: false,
          other: false,
          daily_report: false,
          proof_of_payment: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          sales_officers: true,
          whitelist_user: true,
          setting: true,
          termsNcond: true,
          survey: true,
          promotion: true,
          plants: true,
          marketing: true,
          notification: true,
          orderBlock: true,
        };
      }
    } else if (roleData.indexOf("$oba") > -1) {
      currMenuSett = {
        config: false,
        users: false,
        product: true,
        sales_order: true,
        schemes: true,
        other: true,
        daily_report: true,
        survey: true,
        promotion: true,
        plants: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$ra") > -1) {
      currMenuSett = {
        config: false,
        users: false,
        product: false,
        sales_order: false,
        schemes: false,
        other: false,
        daily_report: true,
        survey: true,
        promotion: true,
        plants: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("Internal Control") > -1) {
      setIsSalesOfficerPresent(false);
      currMenuSett = {
        users: true,
        sales_order: true,
        daily_report: false,
        notification: false,
        marketing: false,
        promotion: false,
        plants: false,
        survey: false,
      };
    } else if (roleData.indexOf("Marketing") > -1) {
      console.log("inside Marketing");
      setComplaintStatus(false);
      currMenuSett = {
        users: true,
        sales_order: true,
        survey: true,
        promotion: true,
        plants: false,
        marketing: true,
        notification: true,
      };
    } else {
      currMenuSett = {
        config: false,
        users: false,
        product: false,
        sales_order: false,
        schemes: false,
        other: false,
        daily_report: false,
        survey: true,
        promotion: true,
        plants: false,
        marketing: true,
        notification: true,
      };
    }
    setMenuSettings(currMenuSett);
  };

  const handleClick = (keyName) => {
    let MenuObj = {};
    MenuObj["umOpen"] = false;
    MenuObj["uOpen"] = false;
    MenuObj["lpOpen"] = false;
    MenuObj["proofOpen"] = false;
    MenuObj["bashBanner"] = false;
    MenuObj["emailerBanner"] = false;
    MenuObj["prodImg"] = false;
    MenuObj["clickitProd"] = false;
    MenuObj["aOpen"] = false;
    MenuObj["pOpen"] = false;
    MenuObj["slOpen"] = false;
    MenuObj["scOpen"] = false;
    MenuObj["omOpen"] = false;
    MenuObj["rpOpen"] = false;
    MenuObj["cmangOpen"] = false;
    MenuObj["isnotifOpen"] = false;
    MenuObj["soNotifOpen"] = false;
    MenuObj["tcOpen"] = false;
    MenuObj["smOpen"] = false;
    MenuObj["pmOpen"] = false;
    MenuObj["plantOpen"] = false;
    MenuObj["svOpen"] = false;
    MenuObj["pbpOpen"] = false;
    MenuObj["soSmOpen"] = false;
    MenuObj[`${keyName}`] = !menuObj[`${keyName}`];
    setMenuObj(MenuObj);
  };

  if (loginType !== "password_based") {
    loggedInUserValidity();
  } else {
    console.log("Do not check for isSignedIn");
  }

  // console.log('state.menuSettings', state.menuSettings);
  const translate = useTranslate();

  return (
    <Authenticated>
      <Sidebar>
        <Menu className={"nv-menu"}>
          <MenuItemLink
            leftIcon={<DashboardIcon />}
            key={"dashboard"}
            className={`nv-menu-single`}
            to={`/`}
            primaryText={translate("resources.my_menu.fields.dashboard")}
            onClick={props.onMenuClick}
          />
          {menuSettings.config && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("umOpen");
                }}
                className={"nv-menu-outer"}
              >
                <ListItemText
                  inset
                  primary="Config"
                  className={"nv-menu-text"}
                />
                {umOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={umOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"branches"}
                    classes={props.classes}
                    to={`/branches`}
                    primaryText={"Branches Master"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"subbranch"}
                    classes={props.classes}
                    to={`/subbranch`}
                    primaryText={"Sub Branches Master"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"opcos"}
                    classes={props.classes}
                    to={`/opcos`}
                    primaryText={"Opcos Master"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.admin &&
            (whiteListUsers || salesOfficersStatus || settingListStatus) && (
              // ( state.menuSettings.sales_officers || state.menuSettings.setting || state.menuSettings.whitelist_user ) &&
              <>
                <ListItem
                  button
                  onClick={() => {
                    handleClick("aOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<PersonIcon />}
                  <ListItemText
                    inset
                    primary={translate("resources.my_menu.fields.admin")}
                    className={"nv-menu-text"}
                  />
                  {menuObj.aOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={menuObj.aOpen}>
                  <List className={"nv-menu-inner"}>
                    {whiteListUsers && menuSettings.whitelist_user && (
                      <MenuItemLink
                        key={"whitelist_users"}
                        classes={props.classes}
                        to={`/whitelist_users`}
                        primaryText={translate(
                          "resources.my_menu.fields.whitelist_user"
                        )}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {salesOfficersStatus &&
                      menuSettings.sales_officers &&
                      isSalesOfficerPresent && (
                        <MenuItemLink
                          key={"sales_officers"}
                          classes={props.classes}
                          to={`/sales_officers`}
                          primaryText={"Sales Officers"}
                          onClick={props.onMenuClick}
                        />
                      )}
                    {settingListStatus && menuSettings.setting && (
                      <MenuItemLink
                        key={"settings"}
                        classes={props.classes}
                        to={`/settings`}
                        primaryText={"Settings"}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {menuSettings.termsNcond && (
                      <MenuItemLink
                        key={"terms_and_condition_list"}
                        classes={props.classes}
                        to={`/terms_and_condition_list`}
                        primaryText={translate(
                          "resources.my_menu.fields.terms"
                        )}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {menuSettings.priceUpdate && (
                      <MenuItemLink
                        key={"madagascar_products_list"}
                        classes={props.classes}
                        to={`/madagascar_products_list`}
                        primaryText={"Price Update"}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {/* {menuSettings.orderBlock && (
                        <MenuItemLink
                          key={"order_block_create"}
                          classes={props.classes}
                          to={`/order_block_create`}
                          primaryText={"Ordering Blocked"}
                          onClick={props.onMenuClick}
                        />
                      )} */}
                    {userLocale != "fr-FR" && (
                      <MenuItemLink
                        key={"create_business_from_csv"}
                        classes={props.classes}
                        to={`/create_business_from_csv`}
                        primaryText={translate(
                          "resources.my_menu.fields.create_business"
                        )}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {/* {menuSettings.termsNcond &&
                        <MenuItemLink key={'term_and_conditions'} classes={props.classes} to={`/term_and_conditions`} primaryText={'Terms & Conditions'} onClick={props.onMenuClick} />
                      } */}

                    {/* <MenuItemLink
                        key={"sap_contracts_product_list"}
                        classes={props.classes}
                        to={`/sap_contracts_product_list`}
                        primaryText={"Product List"}
                        onClick={props.onMenuClick}
                      /> */}
                  </List>
                </Collapse>
              </>
            )}
          {menuSettings.users && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("uOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<AccountIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.users")}
                  className={"nv-menu-text"}
                />
                {menuObj.uOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.uOpen}>
                <List className={"nv-menu-inner"}>
                  {/* <MenuItemLink  key={'whitelist_users'} classes={props.classes} to={`/whitelist_users`} primaryText={'Whitelist Users'} onClick={props.onMenuClick} /> */}
                  <MenuItemLink
                    key={"businesses"}
                    classes={props.classes}
                    to={`/businesses`}
                    primaryText={translate("resources.my_menu.fields.sold_to")}
                    onClick={props.onMenuClick}
                  />
                  {
                    permissions === 'isManual' &&
                    <MenuItemLink
                      key={"sap_contracts"}
                      classes={props.classes}
                      to={`/sap_contracts`}
                      primaryText={"Contracts"}
                      onClick={props.onMenuClick}
                    />
                  }
                  {
                    permissions === 'isManual' &&
                    <MenuItemLink
                      key={"sap_business_sites"}
                      classes={props.classes}
                      to={`/sap_business_sites`}
                      primaryText={"Ship Tos"}
                      onClick={props.onMenuClick}
                    />
                  }
                  <MenuItemLink
                    key={"users"}
                    classes={props.classes}
                    to={`/users`}
                    primaryText={translate(
                      "resources.my_menu.fields.clickit_user"
                    )}
                    onClick={props.onMenuClick}
                  />
                  {is_uae_sms_del && (
                    <MenuItemLink
                      key={"sms_delivery_reports"}
                      classes={props.classes}
                      to={{
                        pathname: "/sms_delivery_reports",
                        search: `filter=${JSON.stringify({
                          country_id: 13,
                        })}`,
                      }}
                      primaryText={"SMS Deliveries"}
                      onClick={props.onMenuClick}
                    />
                  )}

                  {targetUpload && (
                    <div>
                      <MenuItemLink
                        key={"business_targets"}
                        classes={props.classes}
                        to={`/business_targets`}
                        primaryText={"Targets"}
                        onClick={props.onMenuClick}
                      />
                    </div>
                  )}
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.product && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("pOpen");
                }}
                className={"nv-menu-outer"}
              >
                <ListItemText
                  inset
                  primary="Product"
                  className={"nv-menu-text"}
                />
                {pOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={pOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"productsmaster"}
                    classes={props.classes}
                    to={`/productsmaster`}
                    primaryText={"Product Master"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"prodmasteropbrmap"}
                    classes={props.classes}
                    to={`/prodmasteropbrmap`}
                    primaryText={"Products Master For Opco & Branch Mappings"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"product"}
                    classes={props.classes}
                    to={`/product`}
                    primaryText={"Product Retailer Mapping"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.sales_order && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("slOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<OrderIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.digital_order")}
                  className={"nv-menu-text"}
                />
                {menuObj.slOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.slOpen}>
                <List className={"nv-menu-inner"}>
                  {/* <MenuItemLink  key={'sales'} classes={props.classes} to={`/sales`} primaryText={'Sales'} onClick={props.onMenuClick} />
                  <MenuItemLink  key={'customer_payments'} classes={props.classes} to={`/customer_payments`} primaryText={'Customer Payments'} onClick={props.onMenuClick} /> */}
                  <MenuItemLink
                    key={"sap_digital_app_orders"}
                    classes={props.classes}
                    to={`/sap_digital_app_orders`}
                    // primaryText={"Digital Orders via app"}
                    primaryText={translate(
                      "resources.my_menu.fields.digital_order"
                    )}
                    onClick={props.onMenuClick}
                  />
                  {getLocalStorageKey("show_all_orders") && (
                    <MenuItemLink
                      key={"sap_digital_orders"}
                      classes={props.classes}
                      to={`/sap_digital_app_orders`}
                      primaryText={translate(
                        "resources.my_menu.fields.digital_order"
                      )}
                      onClick={props.onMenuClick}
                    />
                  )}
                  {!hideReceivedYesNoStatus && (
                    <div>
                      <MenuItemLink
                        key={"sap_digital_disputed_orders"}
                        classes={props.classes}
                        to={`/sap_digital_disputed_orders`}
                        primaryText={translate(
                          "resources.my_menu.fields.dispute_digital_order"
                        )}
                        onClick={props.onMenuClick}
                      />
                      <MenuItemLink
                        key={"received_digital_orders"}
                        classes={props.classes}
                        to={`/received_digital_orders`}
                        primaryText={translate(
                          "resources.my_menu.fields.received_digital_orders"
                        )}
                        onClick={props.onMenuClick}
                      />
                    </div>
                  )}
                  {/* <MenuItemLink key={'digital_order_transactions'} classes={props.classes} to={`/digital_order_transactions`} primaryText={'Digital Order Transactions'} onClick={props.onMenuClick} /> */}
                  {/* {
                    DigitalOrderSystem() ==== 'isManual' &&
                      <MenuItemLink key={'sap_sdo_for_orders'} classes={props.classes} to={`/sap_sdo_for_orders`} primaryText={'Digital Orders SDs'} onClick={props.onMenuClick} />
                  } */}
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.proof_of_payment && proofStatus && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("proofOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<ReceiptIcon />}
                <ListItemText
                  inset
                  primary={translate(
                    "resources.my_menu.fields.proof_of_payments"
                  )}
                  className={"nv-menu-text"}
                />
                {menuObj.proofOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.proofOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"proof_of_payments"}
                    classes={props.classes}
                    to={`/proof_of_payments`}
                    primaryText={translate(
                      "resources.my_menu.fields.proof_records"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {
            // menuSettings.dashboard_banners && dashBannerStatus &&
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("emailerBanner");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<ViewCarouselIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.emailer_banner")}
                  className={"nv-menu-text"}
                />
                {menuObj.emailerBanner ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.emailerBanner}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"emailer_banners"}
                    classes={props.classes}
                    to={`/emailer_banners`}
                    primaryText={translate(
                      "resources.my_menu.fields.emailer_banner_list"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          }
          {
            // menuSettings.dashboard_banners && dashBannerStatus &&
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("bashBanner");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<ViewCarouselIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.home_banner")}
                  className={"nv-menu-text"}
                />
                {menuObj.bashBanner ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.bashBanner}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"dashboard_banners"}
                    classes={props.classes}
                    to={`/dashboard_banners`}
                    primaryText={translate(
                      "resources.my_menu.fields.mobile_banner_list"
                    )}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"dashboard_banners_web"}
                    classes={props.classes}
                    to={`/dashboard_banners_web`}
                    primaryText={translate(
                      "resources.my_menu.fields.web_banner_list"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          }
          {
            // menuSettings.productsmaster && productsMasterStatus &&
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("prodImg");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<ProductImageIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.product_image")}
                  className={"nv-menu-text"}
                />
                {menuObj.prodImg ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.prodImg}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"productsmaster"}
                    classes={props.classes}
                    to={`/productsmaster`}
                    primaryText={translate(
                      "resources.my_menu.fields.product_inmage_list"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          }
          {
            // menuSettings.productsmaster && productsMasterStatus &&
            roleData[0] === "$csa" && userLocale == "en-GB" && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    handleClick("clickitProd");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ProductImageIcon />}
                  <ListItemText
                    inset
                    primary={translate(baseThemeColor === 'clickittheme'?
                      "resources.my_menu.fields.clickit_products" : "resources.my_menu.fields.holcim_products"
                    )}
                    className={"nv-menu-text"}
                  />
                  {menuObj.clickitProd ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={menuObj.clickitProd}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"clickit_products"}
                      classes={props.classes}
                      to={`/clickit_products`}
                      primaryText={translate(
                        "resources.my_menu.fields.image_list"
                      )}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )
          }
          {complaintStatus && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("cmangOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<ContactSupportIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.contact_us")}
                  className={"nv-menu-text"}
                />
                {menuObj.cmangOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.cmangOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"Contact Us"}
                    classes={props.classes}
                    to={`/complaints`}
                    primaryText={translate(
                      "resources.my_menu.fields.contact_us"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}

          {menuSettings.schemes && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("scOpen");
                }}
                className={"nv-menu-outer"}
              >
                <ListItemText
                  inset
                  primary="Schemes"
                  className={"nv-menu-text"}
                />
                {scOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={scOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"loyaltys"}
                    classes={props.classes}
                    to={`/loyaltys`}
                    primaryText={"Loyalties"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"scheme"}
                    classes={props.classes}
                    to={`/scheme`}
                    primaryText={"Schemes"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"tagtoschememap"}
                    classes={props.classes}
                    to={`/tagtoschememap`}
                    primaryText={"Tag to Scheme Mappings"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"dashbanner"}
                    classes={props.classes}
                    to={`/dashbanner`}
                    primaryText={"Dashboard Banners"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.other && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("omOpen");
                }}
                className={"nv-menu-outer"}
              >
                <ListItemText
                  inset
                  primary="Other Master"
                  className={"nv-menu-text"}
                />
                {omOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={omOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"tag"}
                    classes={props.classes}
                    to={`/tag`}
                    primaryText={"Tag"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"language"}
                    classes={props.classes}
                    to={`/language`}
                    primaryText={"Languages"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"cntrylangmap"}
                    classes={props.classes}
                    to={`/cntrylangmap`}
                    primaryText={"Country Language Mappings"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.daily_report && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("rpOpen");
                }}
                className={"nv-menu-outer"}
              >
                <ListItemText
                  inset
                  primary="Daily Reports"
                  className={"nv-menu-text"}
                />
                {menuObj.rpOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.rpOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"activity_reports"}
                    classes={props.classes}
                    to={`/activity_reports`}
                    primaryText={"Activity Report"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"ordering_reports"}
                    classes={props.classes}
                    to={`/ordering_reports`}
                    primaryText={"Ordering Report"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"logins_reports"}
                    classes={props.classes}
                    to={`/logins_reports`}
                    primaryText={"Logins Report"}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"orders_reports"}
                    classes={props.classes}
                    to={`/orders_reports`}
                    primaryText={"Orders Report"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.notification && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("isnotifOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<NotificationsIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.notification")}
                  className={"nv-menu-text"}
                />
                {menuObj.isnotifOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.isnotifOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"In_app_notifications"}
                    classes={props.classes}
                    to={`/in_app_notifications`}
                    primaryText={translate(
                      "resources.my_menu.fields.in_app_message"
                    )}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"send_bulk_notifications"}
                    classes={props.classes}
                    to={`/send_bulk_notifications`}
                    primaryText={translate(
                      "resources.my_menu.fields.bulk_in_app_messages"
                    )}
                    onClick={props.onMenuClick}
                  />
                  {isSalesOfficerPresent && (
                    <MenuItemLink
                      key={"so_in_app_notifications"}
                      classes={props.classes}
                      to={`/so_in_app_notifications`}
                      primaryText={"Sales Officer app messages"}
                      onClick={props.onMenuClick}
                    />
                  )}
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.marketing && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("smOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<MessageIcon />}
                <ListItemText
                  inset
                  primary={translate("resources.my_menu.fields.marketing")}
                  className={"nv-menu-text"}
                />
                {menuObj.smOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.smOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"send_message"}
                    classes={props.classes}
                    to={`/sms_blasts`}
                    primaryText={translate("resources.my_menu.fields.send_msg")}
                    onClick={props.onMenuClick}
                  />
                  <MenuItemLink
                    key={"send_sms_bulk_notifications"}
                    classes={props.classes}
                    to={`/send_sms_bulk_notifications`}
                    primaryText={translate(
                      "resources.my_menu.fields.send_bulk_message"
                    )}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}

          {isSalesOfficerPresent && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("soSmOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<MessageIcon />}
                <ListItemText
                  inset
                  primary="Sales Officer Marketing"
                  className={"nv-menu-text"}
                />
                {menuObj.soSmOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.soSmOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"send_message"}
                    classes={props.classes}
                    to={`/so_sms_blasts`}
                    primaryText={"Sales Officer Send message"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.plants && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("plantOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<FactoryIcon />}
                <ListItemText
                  inset
                  primary="Plants"
                  className={"nv-menu-text"}
                />
                {menuObj.plantOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.plantOpen}>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"plants"}
                    classes={props.classes}
                    to={`/rocks_plants`}
                    primaryText={"Aggregate Plants"}
                    onClick={props.onMenuClick}
                  />
                </List>
                <List className={"nv-menu-inner"}>
                  <MenuItemLink
                    key={"plants"}
                    classes={props.classes}
                    to={`/sap_plants`}
                    primaryText={"Asphalt Plants"}
                    onClick={props.onMenuClick}
                  />
                </List>
              </Collapse>
            </>
          )}
          {/* {menuSettings.promotion && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    handleClick("pmOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<RedeemIcon />}
                  <ListItemText
                    inset
                    primary="Promotion"
                    className={"nv-menu-text"}
                  />
                  {pmOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={pmOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"promotion_notifications"}
                      classes={props.classes}
                      to={`/promotions`}
                      primaryText={"Promotions"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )} */}
          {/* {menuSettings.loyaltyPoints && loyaltyPointsList && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("lpOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<LoyaltyIcon />}
                <ListItemText
                  inset
                  primary="Loyalty Points"
                  className={"nv-menu-text"}
                />
                {menuObj.lpOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.lpOpen}>
                <List className={"nv-menu-inner"}>
                  <div>
                    <MenuItemLink
                      key={"loyalty_points"}
                      classes={props.classes}
                      to={`/loyalty_points`}
                      primaryText={"Loyalty Points List"}
                      onClick={props.onMenuClick}
                    />
                  </div>
                </List>
              </Collapse>
            </>
          )} */}
          {menuSettings.loyaltyPoints && loyaltyPointsList && userLocale == "en-GB" && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("lpOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<LoyaltyIcon />}
                <ListItemText
                  inset
                  primary={translate(
                    "resources.my_menu.fields.loyalty_points"
                  )}
                  className={"nv-menu-text"}
                />
                {menuObj.lpOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.lpOpen}>
                <List className={"nv-menu-inner"}>
                  <div>
                    <MenuItemLink
                      key={"user_loyalty_points"}
                      classes={props.classes}
                      to={`/user_loyalty_points`}
                      primaryText={translate(
                        "resources.my_menu.fields.loyalty_points"
                      )}
                      onClick={props.onMenuClick}
                    />
                  </div>
                </List>
                <List className={"nv-menu-inner"}>
                  <div>
                    <MenuItemLink
                      key={"loyalty_rewards"}
                      classes={props.classes}
                      to={`/loyalty_rewards`}
                      primaryText={translate(
                        "resources.my_menu.fields.rewards_list"
                      )}
                      onClick={props.onMenuClick}
                    />
                  </div>
                </List>
              </Collapse>
            </>
          )}
          {menuSettings.survey && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("svOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<StarIcon />}
                <ListItemText
                  inset
                  primary="Survey"
                  className={"nv-menu-text"}
                />
                {menuObj.svOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.svOpen}>
                <List className={"nv-menu-inner"}>
                  <div>
                    <MenuItemLink
                      key={"survey"}
                      classes={props.classes}
                      to={`/surveys`}
                      primaryText={"Surveys"}
                      onClick={props.onMenuClick}
                    />
                  </div>
                </List>
              </Collapse>
            </>
          )}
          {paymentList && (
            <>
              <ListItem
                button
                onClick={() => {
                  handleClick("pbpOpen");
                }}
                className={"nv-menu-outer"}
              >
                {" "}
                {<PaymentIcon />}
                <ListItemText
                  inset
                  primary="Probase Payments"
                  className={"nv-menu-text"}
                />
                {menuObj.pbpOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={menuObj.pbpOpen}>
                <List className={"nv-menu-inner"}>
                  <div>
                    <MenuItemLink
                      key={"probase_payments"}
                      classes={props.classes}
                      to={`/probase_payments`}
                      primaryText={"Probase Payment List"}
                      onClick={props.onMenuClick}
                    />
                  </div>
                </List>
              </Collapse>
            </>
          )}
        </Menu>
      </Sidebar>
    </Authenticated>
  );
};

// const mapStateToProps = (state) => ({
//   resources: getResources(state),
// });

// export default withRouter(
//   connect(mapStateToProps, { changeLocale: changeLocaleAction })(
//     withStyles(styles)(MyMenu)
//   )
// );

MyMenu.propTypes = {
  classes: PropTypes.any,
  resources: PropTypes.any,
  onMenuClick: PropTypes.any,
  logout: PropTypes.any,
};

// export default withRouter((withStyles(styles)(MyMenu)));
export default MyMenu;
